/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* Nali: autoplay hosted product videos when visible (2026-10-02). */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const states = new Map();
  const selector = 'deferred-media.product__media, hover-images video, [data-nali-card-video] video';
  const play = (state) => {
    const video = state.video;
    if (!video || !state.visible || document.hidden) return;
    video.muted = true;
    video.playsInline = true;
    const pending = video.play();
    if (pending) pending.catch(() => {
      // Keep a manual playback option when the browser denies autoplay.
      video.controls = true;
    });
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
      if (state.visible && !state.video) {
        const source = entry.target.querySelector('template')?.content.querySelector('video');
        if (!source) return;
        state.video = source.cloneNode(true);
        state.video.muted = true;
        state.video.defaultMuted = true;
        state.video.playsInline = true;
        state.video.autoplay = true;
        entry.target.appendChild(state.video);
        entry.target.setAttribute('loaded', 'true');
      }
      if (state.visible) play(state);
      else state.video?.pause();
    });
  }, {threshold: [0, 0.1]});

  function register(root) {
    const candidates = [];
    if (root.matches?.(selector)) candidates.push(root);
    candidates.push(...root.querySelectorAll(selector));
    candidates.forEach((element) => {
      if (states.has(element)) return;
      const deferred = element.matches('deferred-media');
      if (deferred && !element.querySelector('template')?.content.querySelector('video')) return;
      const state = {video: deferred ? element.querySelector('video') : element, visible: false};
      states.set(element, state);
      if (!deferred && element.closest('hover-images')) {
        // Broadcast normally pauses card videos on mouseleave. Let visibility
        // control native videos while preserving its external-video behavior.
        const card = element.closest('hover-images');
        customElements.whenDefined('hover-images').then(() => {
          if (!card.isConnected || card.naliVideoAutoplay) return;
          const original = card.videoActions;
          if (typeof original !== 'function') return;
          card.naliVideoAutoplay = true;
          card.videoActions = function () {
            if (this.querySelector('[data-host="vimeo"], [data-host="youtube"]')) {
              return original.call(this);
            }
          };
        });
      }
      observer.observe(element);
    });
  }

  function init() {
    register(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) register(node);
        });
      });
      states.forEach((state, element) => {
        if (!element.isConnected) {
          observer.unobserve(element);
          states.delete(element);
        }
      });
    }).observe(document.body, {childList: true, subtree: true});
    document.addEventListener('visibilitychange', () => {
      states.forEach((state) => {
        if (document.hidden) {
          state.resume = !!state.video && !state.video.paused;
          state.video?.pause();
        } else if (state.resume) {
          state.resume = false;
          play(state);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
